

import { FeeLevelType } from "../../../modules/Utilities/PolicyTerms/types";
import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getFeeLevel = async () => {
  const { data } =
    await axios.get(`${api_base_url}/PolicyFeeConfiguration/FeeLevel
  `);
  //const { data } = await axios.get("https://localhost:44399/api/FeeLevel");
  return data;
};
//Insert New FeeLevel
export const addFeeLevel = async (newFeeLevel) => {

  const { data } = await axios.post(
    `${api_base_url}/PolicyFeeConfiguration/FeeLevel
  `,
    newFeeLevel
  );
  return data;
};
// Update FeeLevel
export const updateFeeLevel = async (updatedFeeLevel: FeeLevelType) => {
  await axios.put(
    `${api_base_url}/PolicyFeeConfiguration/FeeLevel${updatedFeeLevel.feeLevelId}`,
    updatedFeeLevel
  );
};
//Search FeeLevel
export const searchFeeLevel = async (searchInputsData) => {
  const data = {
    FeeLevelName: searchInputsData.FeeLevelName,
  };
  return await axios
    .post(
      `${api_base_url}/PolicyFeeConfiguration/FeeLevel
    /SearchFeeLevel`,
      data
    )
    .then((res) => res.data);
};

//Delete FeeLevel by Id
export const deleteFeeLevel = async (FeeLevelId: number) => {
  await axios.delete(`${api_base_url}/PolicyFeeConfiguration/FeeLevel
  /${FeeLevelId}`);
};
//

export const deleteFeeLevels = async (FeeLevelIds) => {
  await axios.delete(
    `${api_base_url}/PolicyFeeConfiguration/FeeLevel${FeeLevelIds}`,
    {
      data: FeeLevelIds,
    }
  );
};
